import { useStores } from "@/stores";
import type { AuthStoreInstance } from "@/stores/types";

/**
 * Access the MST AuthStore from React components.
 * Components consuming observable values should be wrapped with `observer` from mobx-react-lite.
 */
export function useAuthStore(): AuthStoreInstance {
  const root = useStores();
  return root.authStore;
}
